import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { http } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

export default function UnsubNotify() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");
  const [slug, setSlug] = useState(null);
  const ran = useRef(false);

  useEffect(() => {
    // Guard against React.StrictMode's double-invocation in dev — this
    // endpoint deletes the row on first hit and would 404 on the second,
    // flipping our UI into a false error state.
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) { setState("error"); return; }
    http.get(`/access-restricted/unsubscribe?token=${encodeURIComponent(token)}`)
      .then((r) => { setState("ok"); setSlug(r.data.brand_slug); })
      .catch(() => setState("error"));
  }, [params]);

  return (
    <div className="bp-container py-24 text-center max-w-xl" data-testid="unsub-notify-page">
      {state === "loading" && <div className="animate-pulse h-6 w-40 bg-neutral-200 mx-auto" />}
      {state === "ok" && (
        <>
          <h1 className="font-serif text-4xl mb-4" data-testid="unsub-notify-title">{t.notify_unsub_title}</h1>
          <p style={{ color: "var(--bp-text-secondary)" }}>{t.notify_unsub_body}</p>
          {slug && <Link to={`/brands/${slug}`} className="bp-link mt-6 inline-block">← {slug}</Link>}
        </>
      )}
      {state === "error" && (
        <>
          <h1 className="font-serif text-4xl mb-4" data-testid="unsub-notify-error">{t.notify_unsub_invalid}</h1>
          <Link to="/" className="bp-link">Home →</Link>
        </>
      )}
    </div>
  );
}
